















































import { Component, Vue, Prop } from "vue-property-decorator";
import CockpitEntryInfoItemComponent, {
  CockpitEntryInfo,
} from "./CockpitEntryInfoItem.vue";
import { COLOR_COCKPIT_CARD_DEFAULT, COLOR_COCKPIT_CARD_DEFAULT_DARK, COLOR_COCKPIT_CARD_LIST_ITEM, COLOR_LAST_VISITED_ITEM } from "@/utils/colors";
import { themed } from "@/utils/Theme";

@Component({
  components: {
    "cockpit-entry-info": CockpitEntryInfoItemComponent,
  },
})
export default class CockpitCardComponent extends Vue {
  @Prop() title!: string;
  @Prop() items!: CockpitEntryInfo[];
  @Prop({ default: "" }) color!: string;

  @Prop({ default: false }) isDummyCard!: boolean;

  listBackgroundColor = COLOR_COCKPIT_CARD_LIST_ITEM;

  /** Card background: an explicit color from the parent, else a theme-aware default. */
  get cardColor() {
    return (
      this.color ||
      themed(COLOR_COCKPIT_CARD_DEFAULT, COLOR_COCKPIT_CARD_DEFAULT_DARK)
    );
  }

  get showItems() {
    return (
      this.items &&
      this.items.filter((item) => item.shouldBeDisplayed).length > 0
    );
  }

  get maxCounterWidth() {
    const maxCountLength = Math.max(
      ...this.items
        .filter((item) => item.data.count !== undefined)
        .map((item) => item.data.count.toString().length)
    );

    return `${(maxCountLength * 10)}px`;
  }

  calculateBackgroundStyle(shouldBeHighlighted?: boolean) {
    return shouldBeHighlighted
      ? `background-color: ${COLOR_LAST_VISITED_ITEM}`
      : "";
  }
}
